import { Col, Row, Typography } from 'antd';
import React, { useRef, useState } from 'react';
import { Outlet } from 'react-router';
import login from '@assets/images/auth-bg.png';
import device from '@assets/images/device.png';
import { IoChevronBack, IoChevronForward } from 'react-icons/io5';
import { Swiper, SwiperSlide } from 'swiper/react';
import { twMerge } from 'tailwind-merge';
import { MainTitle } from '@components/ui/typography';
import useColors from '../../hooks/useColors';

const AuthLayout = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    const swiperRef = useRef(null);
    const { colorPrimary } = useColors();

    return (
        <Row>
            <Col lg={10} xs={24} className="h-screen relative flex">
                <div className="flex flex-col items-center px-6 mx-auto my-auto py-12 max-h-full overflow-auto no-scrollbar">
                    <Outlet />
                </div>
            </Col>

            <Col
                lg={14}
                xs={0}
                className="h-screen rounded-none md:rounded-3xl relative"
            >
                <div className="w-full h-full rounded-none">
                    <img
                        className="h-full w-full aspect-[4/3] object-top object-cover "
                        src={login}
                    />
                </div>
                <div
                    className="absolute inset-0 flex flex-col items-center text-center justify-center gap-2 sm:gap-3 2xl:gap-6"
                    style={{ background: colorPrimary }}
                >
                    <MainTitle className="text-white">
                        Cloud Based Security Guard Management
                    </MainTitle>
                    <Typography className="text-white">
                        Sed perspicias unde omnis natus error voluptate.
                    </Typography>
                    {/* <Typography>Sed perspicias unde omnis natus error voluptate.</Typography> */}
                    <div className="w-full select-none">
                        <Swiper
                            ref={swiperRef}
                            slidesPerView={1}
                            onSlideChange={(swiper) =>
                                setActiveIndex(swiper.activeIndex)
                            }
                            speed={750}
                            autoplay={true}
                        >
                            <SwiperSlide>
                                <img
                                    src={device}
                                    className="max-w-[70%] w-full mx-auto"
                                />
                            </SwiperSlide>
                            <SwiperSlide>
                                <img
                                    src={device}
                                    className="max-w-[70%] w-full mx-auto"
                                />
                            </SwiperSlide>
                            <SwiperSlide>
                                <img
                                    src={device}
                                    className="max-w-[70%] w-full mx-auto"
                                />
                            </SwiperSlide>
                            <SwiperSlide>
                                <img
                                    src={device}
                                    className="max-w-[70%] w-full mx-auto"
                                />
                            </SwiperSlide>
                        </Swiper>
                    </div>
                    <div className="flex w-full items-center justify-between max-w-[576px] mx-auto md:px-16 sm:px-8 px-0 mt-2">
                        <span
                            className="text-white cursor-pointer"
                            onClick={() => {
                                swiperRef.current?.swiper?.slidePrev();
                            }}
                        >
                            <IoChevronBack />
                        </span>
                        <div className="flex items-center gap-1 justify-center">
                            {[1, 2, 3, 4].map((item, idx) => {
                                return (
                                    <span
                                        className={twMerge(
                                            'inline-block cursor-pointer bg-white w-4 h-1 duration-300 opacity-50',
                                            idx === activeIndex &&
                                                'w-8 opacity-100',
                                        )}
                                        key={idx}
                                        onClick={() => {
                                            if (swiperRef.current.swiper) {
                                                swiperRef.current.swiper.slideToLoop(
                                                    idx,
                                                );
                                            }
                                        }}
                                    ></span>
                                );
                            })}
                        </div>
                        <span
                            className="text-white cursor-pointer"
                            onClick={() => {
                                swiperRef.current?.swiper?.slideNext();
                            }}
                        >
                            <IoChevronForward />
                        </span>
                    </div>
                </div>
            </Col>
        </Row>
    );
};

export default AuthLayout;
